export default "/images/tiktok.svg?a3c682f8b84a1a584db29f119c4e5361";